"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
const vue_1 = require("vue");
const _withScopeId = n => ((0, vue_1.pushScopeId)("data-v-c87a899a"), n = n(), (0, vue_1.popScopeId)(), n);
const _hoisted_1 = {
    key: 0,
    class: "guarantor-list-title"
};
const _hoisted_2 = { key: 0 };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DetailTitle = (0, vue_1.resolveComponent)("DetailTitle");
    const _component_a_button = (0, vue_1.resolveComponent)("a-button");
    const _component_ListView = (0, vue_1.resolveComponent)("ListView");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
        class: (0, vue_1.normalizeClass)(["guarantor-list", _ctx.id ? '' : 'local-main-page'])
    }, [
        (_ctx.id)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
                (0, vue_1.createVNode)(_component_DetailTitle, {
                    title: "追加担保人信息",
                    collapse: _ctx.collapse,
                    onCollapse: _ctx.onCollapseChange
                }, null, 8, ["collapse", "onCollapse"]),
                (_ctx.extraData && !_ctx.collapse)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, [
                        (0, vue_1.createVNode)(_component_a_button, {
                            type: "primary",
                            onClick: _ctx.loadData
                        }, {
                            default: (0, vue_1.withCtx)(() => [
                                (0, vue_1.createTextVNode)("刷新")
                            ]),
                            _: 1
                        }, 8, ["onClick"]),
                        (_ctx.extraData.overStatus.value === '2' || _ctx.extraData.overStatus.value === '11')
                            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_a_button, {
                                key: 0,
                                style: { "margin-left": "16px" },
                                type: "primary",
                                onClick: _ctx.toBuildGuarantor
                            }, {
                                default: (0, vue_1.withCtx)(() => [
                                    (0, vue_1.createTextVNode)("追加担保人")
                                ]),
                                _: 1
                            }, 8, ["onClick"]))
                            : (0, vue_1.createCommentVNode)("", true)
                    ]))
                    : (0, vue_1.createCommentVNode)("", true)
            ]))
            : (0, vue_1.createCommentVNode)("", true),
        (!_ctx.collapse)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_ListView, {
                key: 1,
                ref: "list-view",
                "complex-list": _ctx.mainData,
                option: _ctx.listOption,
                onMenu: _ctx.onMenu
            }, null, 8, ["complex-list", "option", "onMenu"]))
            : (0, vue_1.createCommentVNode)("", true)
    ], 2));
}
exports.render = render;
